import { Grid, Paper } from '@mui/material';

import Window from '../windows/Window';

import { useWall } from './api/getWall';

interface Props {
  selectedWallId: number;
  openSingleTraceView: (row: number, column: number) => void;
}

const WallView = ({ selectedWallId, openSingleTraceView }: Props) => {
  // Grab updated users to properly display lock icons on windows
  const { data: wall } = useWall({ wallId: selectedWallId });

  if (!wall) return <></>;

  const rowsArray = [...Array(wall.rows)];
  const columnsArray = [...Array(wall.columns)];

  return (
    <>
      {rowsArray.map((row, rowIndex) => (
        <Grid container columns={wall.columns} key={rowIndex}>
          {columnsArray.map((column, columnIndex) => (
            <Grid
              item
              key={`column_${columnIndex}_row_${rowIndex}_wall_${selectedWallId}`}
              xs={1}
              component={Paper}
              style={{ position: 'relative' }}
            >
              <Window
                wallId={selectedWallId}
                row={rowIndex}
                column={columnIndex}
                handleWindowClicked={openSingleTraceView}
              />
            </Grid>
          ))}
        </Grid>
      ))}
    </>
  );
};

export default WallView;
